import apiService from './api.service';
import { FeedItem, FollowStatus, FollowUser } from '@/types/feed';

class FeedService {
  async getPersonalFeed(limit: number = 20): Promise<FeedItem[]> {
    const response = await apiService.get<FeedItem[]>('/feed/personal/', {
      params: { limit },
    });
    return response.data;
  }

  async getSectorFeed(limit: number = 20): Promise<FeedItem[]> {
    const response = await apiService.get<FeedItem[]>('/feed/sector/', {
      params: { limit },
    });
    return response.data;
  }

  async getSocialFeed(limit: number = 20): Promise<FeedItem[]> {
    const response = await apiService.get<FeedItem[]>('/feed/social/', {
      params: { limit },
    });
    return response.data;
  }

  async follow(userId: string): Promise<{ detail: string; is_following: boolean }> {
    const response = await apiService.post<{ detail: string; is_following: boolean }>(`/feed/follow/${userId}/`);
    return response.data;
  }

  async unfollow(userId: string): Promise<void> {
    await apiService.delete(`/feed/follow/${userId}/`);
  }

  async getFollowing(): Promise<FollowUser[]> {
    const response = await apiService.get<FollowUser[]>('/feed/follow/following/');
    return response.data;
  }

  async getFollowers(): Promise<FollowUser[]> {
    const response = await apiService.get<FollowUser[]>('/feed/follow/followers/');
    return response.data;
  }

  async getFollowersCount(userId?: string): Promise<number> {
    const params = userId ? { user_id: userId } : {};
    const response = await apiService.get<{ count: number }>('/feed/follow/followers/count/', {
      params,
    });
    return response.data.count;
  }

  async getFollowStatus(userId: string): Promise<FollowStatus> {
    const response = await apiService.get<FollowStatus>(`/feed/follow/status/${userId}/`);
    return response.data;
  }
}

export const feedService = new FeedService();
